import styled, { keyframes } from "styled-components";
import Link from "../Link";
import HamburgerMenu from "../../img/hamburger-menu.svg"
import CloseIconRaw from "../../img/close-icon.svg"

import ConstellationLogoSvg from "../../img/logos/constellation-logo.svg";

export const Container = styled.div`
  width: 100vw;
  position: fixed;
  z-index: 900;
  top: 0;
  backdrop-filter: blur(4px);
`;

export const BarMenuContainer = styled.div`
  margin-top: 100px;
  width: 100vw;
  top: 0;
  overflow-y: scroll !important;
  background: #1B1E29;
`;

export const ConstellationLogo = styled(ConstellationLogoSvg)`
  path {
    fill: ${(props) => props.showBarOptions ? "#FFF" : props.theme.constellationLogoColor};
  }
`;

export const Nav = styled.div`
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: space-between;
  padding: 20px 24px;
  z-index: 100;
  position: relative;

  background-color: ${(props) => props.showBarOptions ? "#1B1E29" : "transparent"};
`;

export const NavLink = styled(Link)`
  color: ${(props) => props.theme.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;

  margin-right: 60px;

  &:hover {
    color: ${(props) => props.theme.primary};
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    padding: 0px !important;
  }
`;

export const BarsButton = styled.button`
  display: none;
  background: none;
  border: none;

  svg {
    path {
      stroke: ${(props) => props.showBarOptions ? "#FFF" : props.theme.primary};
    }
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const Bars = styled(HamburgerMenu)`
  color: ${(props) => props.theme.primary};
  width: 30px;
  height: 30px;
`;

export const CloseIcon = styled(CloseIconRaw)`
  color: ${(props) => props.theme.primary};
  width: 20px;
  height: 20px;
  margin-top: 8px;
  margin-right: 7px;
  z-index: 10;
`;

export const GetDagLink = styled(Link)`
  color: ${(props) => props.theme.primary};
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;
  margin-right: 30px;

  svg {
    margin-left: 10px;
    font-size: 15px;
    font-weight: normal;

    path {
      fill: ${props => props.theme.primary};
    }
  }

  &:hover {
    color: ${(props) => props.theme.primary};
  }

  @media ${(props) => props.theme.breakpoints && props.theme.breakpoints.tablet} {
    display: none;
  }
`;

const glowAnimation = keyframes`
  0% {
    box-shadow: 0 0 5px #1552EF, 0 0 10px #1552EF, 0 0 15px #1552EF;
  }
  100% {
    box-shadow: 0 0 20px #1552EF, 0 0 25px #1552EF;
  }
`;

export const GlowingCircle = styled.div`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-left: 10px;
  background-color: ${(props) => props.theme.getDagGlowColor};
  -webkit-animation: ${glowAnimation} 1s ease-in-out infinite alternate;
  -moz-animation: ${glowAnimation} 1s ease-in-out infinite alternate;
  animation: ${glowAnimation} 1s ease-in-out infinite alternate;
`;
